export default __webpack_public_path__ + "static/media/MUM_Scrum_Tool.01c9bb18.png";